/**
 * Periodic ajax checker
 *
 * @param url:
 *            the ajax url to check
 * @param options: {
 *            period: the periodic check time onOk: callback when the end condition is reached isComplete: function to test the end of the periodic
 *            check }
 */
define('utils/periodic-checker',['jquery'], function($) {
    return function(url, options) {
        var timer = null;
        var settings = {
            period: 3000,
            onOk: function() {
            },
            isComplete: function() {
            }
        };
        $.extend(settings, options);

        var timerFunction = $.proxy(function() {
            $.ajax({
                type: 'GET',
                url: url,
                success: function(status) {
                    clearTimeout(timer);
                    if (!settings.isComplete.call(this, status)) {
                        timer = setTimeout(timerFunction, settings.period);
                    } else {
                        settings.onOk.call(this, status);
                    }
                },
                error: function() {
                    clearTimeout(timer);
                    timer = setTimeout(timerFunction, settings.period);
                },
                context: this
            });
        }, this);
        timerFunction();

    };
});

